module.exports = __webpack_public_path__ + "static/media/tick_grey.c8e3d4bf.svg";